<template>
  <CRow class="balances pt-4 content-center">
    <CCol class="balances__item mb-2" xs="12" lg="3" v-for="(ItemBalance, index) in balances" :key="`${ItemBalance.channel}-${index}`">
      <label
        :class="ItemBalance.checked == true ? 'border-primary' : 'border-gray-300'"
        class="p-4 border-md rounded-lg d-flex justify-content-between align-content-center align-items-center bg-white border-sm"
        name="channel"
        :for="ItemBalance.channel"
        @click.stop="getValueChannel(ItemBalance.channel)"
      >
        <div class="ml-3">
          <div class="d-flex">
            <CIcon :name="ItemBalance.channel" class="" size="custom-size" label="teste" :height="25" viewBox="0 0 32 32" />
            <p class="mb-0 font-md ml-2 mb-4 font-weight-bold">
              {{ $t(`home.campaignSumary.${ItemBalance.channel}-available`) }}
            </p>
          </div>
          <p class="font-4xl font-weight-bold mt-2 mb-0 text-left">
            {{ numberWithCommas(ItemBalance.currentBalance) }}
          </p>
        </div>
        <CInputRadio type="radio" :show="false" class="balances__radio p-0" name="channel" size="lg" custom :checked="ItemBalance.checked" />
      </label>
    </CCol>
  </CRow>
</template>

<script>
const channelTypeCode = {
  1: 'email',
  2: 'sms',
}
export default {
  name: 'balance',
  props: {
    balances: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      channelTypeCode,
    }
  },

  mounted() {},

  computed: {
    columns() {
      return this.list ? { qnt: 12, list: true } : { qnt: 6, list: false }
    },
  },

  methods: {
    getValueChannel(channel) {
      this.$emit('channelSelected', channel)
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
}
</script>

<style lang="scss" scoped>
.border-md {
  border-width: 2px !important;
}
</style>
